import * as React from "react";
const CorrectIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={38} height={38} {...props}>
    <g data-name="Group 46139" transform="translate(.411 .223)">
      <circle
        cx={19}
        cy={19}
        r={19}
        fill="#0e5492"
        data-name="Ellipse 1544"
        opacity={0.9}
        transform="translate(-.411 -.223)"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="m11.885 19.097 4.469 4.469 8.938-9.577"
        data-name="tick-svgrepo-com (3)"
      />
    </g>
  </svg>
);
export default CorrectIcon;
